import { crTrackerLockPeriodApi } from '@ge/feat-analyze/services';

export const fetchCRTrackerLockPeriodApi = async ({ contractId, currentDate }) => {
  try {
    const response = await crTrackerLockPeriodApi({
      contractId,
      currentDate,
    });
    return response;
  } catch (error) {
    console.error('CR tracker error response : ', error);
  }
};
